const RUNTIME_TO_SNIPPET_LANGUAGE: Record<string, string> = {
  dotnet: 'csharp',
  csharp: 'csharp',
  cs: 'csharp',
  javascript: 'javascript',
  js: 'javascript',
  typescript: 'typescript',
  ts: 'typescript',
  python: 'python',
  py: 'python',
  java: 'java',
  php: 'php',
  ruby: 'ruby',
  rb: 'ruby',
  bash: 'bash',
  sh: 'bash',
  shell: 'shell',
  docker: 'docker',
  json: 'json',
  yaml: 'yaml',
  yml: 'yaml',
}

const FENCE_LANG_TO_RUNTIME: Record<string, string> = {
  dotnet: 'dotnet',
  csharp: 'dotnet',
  cs: 'dotnet',
  javascript: 'javascript',
  js: 'javascript',
  typescript: 'javascript',
  ts: 'javascript',
  python: 'python',
  py: 'python',
  java: 'java',
  php: 'php',
  ruby: 'ruby',
  rb: 'ruby',
}

export function normalizeDocumentationRuntime(runtimeOrFenceLang: string): string {
  const key = runtimeOrFenceLang.toLowerCase()
  return FENCE_LANG_TO_RUNTIME[key] ?? key
}

export function mapRuntimeToSnippetLanguage(runtimeOrFenceLang: string): string {
  const key = runtimeOrFenceLang.toLowerCase()
  const runtime = normalizeDocumentationRuntime(runtimeOrFenceLang)
  return RUNTIME_TO_SNIPPET_LANGUAGE[runtime] ?? RUNTIME_TO_SNIPPET_LANGUAGE[key] ?? key
}
